/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { NormativeDocumentVersionScopeFilter } from './normativeDocumentVersionScopeFilter';


export interface NormativeDocumentVersionIncludeFilterItems { 
    relation?: NormativeDocumentVersionIncludeFilterItems.RelationEnum;
    scope?: NormativeDocumentVersionScopeFilter;
}
export namespace NormativeDocumentVersionIncludeFilterItems {
    export type RelationEnum = 'document' | 'file' | 'approver';
    export const RelationEnum = {
        Document: 'document' as RelationEnum,
        File: 'file' as RelationEnum,
        Approver: 'approver' as RelationEnum
    };
}


